<template>
    <div>
        <div class="lib-cards">
            <div>
                <h2>AHAs</h2>
                <p>Create AHAs in minutes using our AHA library with 1,000’s of completed AHAs.</p>
                <div class="see-library">
                    <a href="javascript:void(0)" @click="showAhaInfo" class="lib-arrow-link">See our AHA Library</a>
                </div>
                <ul>
                    <li><i class="fa-solid fa-check"></i> Library of 1,000s of completed & customizable AHAs</li>
                    <li><i class="fa-solid fa-check"></i> Checklist of AHA Steps, Tools & Equipment - Just point & click</li>
                    <li><i class="fa-solid fa-check"></i> <a href="/activity-hazard-analysis">AHA Builder</a>, customize your AHAs step by step</li>
                </ul>
                <div class="options">
                    <label>Select your annual AHA needs:</label>
                    <lib-radio-select
                        name="ahas-radio-select"
                        :options="onlyAhasOptions"
                        :value="value.ahas"
                        @input="$emit('input', {...value, ahas: $event})"
                    ></lib-radio-select>
                </div>
              <div class="spacer"></div>
                <lib-pricing-widget
                    :yearly="ahasYearly"
                    :one-time="ahasOneTime"
                ></lib-pricing-widget>
                <slot
                    :can-purchase="!!ahasYearly || !!ahasOneTime"
                    :cart="ahasCart"
                ></slot>
            </div>
            <div>
                <h2>Plans</h2>
                <p>Complete, fully editable administrative and safety plans.</p>
                <div class="see-library">
                    <a href="javascript:void(0)" @click="showPlanInfo" class="lib-arrow-link">See our Plan Library</a>
                </div>
                <ul>
                    <li><i class="fa-solid fa-check"></i> Library of 27 of customizable Plans, including: APP, QCP, EPP, & <a href="javascript:void(0)" @click="showPlanInfo">More</a></li>
                    <li><i class="fa-solid fa-check"></i> Automated information input- Team info, Maps, Safety info, & More</li>
                    <li><i class="fa-solid fa-check"></i> Access to our <a href="/documents">Plan Builder</a>, customize your Plans step by step</li>
                </ul>

                <div class="options">
                    <label>Select your annual Plan needs:</label>
                    <lib-radio-select
                        name="plans-radio-select"
                        :options="plansOptions"
                        :value="value.plans"
                        @input="$emit('input', {...value, plans: $event})"
                    ></lib-radio-select>
                </div>
              <div class="spacer"></div>
                <lib-pricing-widget
                    :yearly="plansYearly"
                ></lib-pricing-widget>
                <slot
                    :can-purchase="!!plansYearly"
                    :cart="plansCart"
                ></slot>
            </div>
            <div>
                <h2>Combo Discount</h2>
                <div class="badge">Best Value</div>
                <p>Combine AHAs and Plans together and get a discounted rate.</p>
                <ul>
                    <li><i class="fa-solid fa-check"></i> Everything you get when you purchase both AHAs and Plans at a discounted rate</li>
                </ul>
                <div class="spacer"></div>
                <div class="options">
                    <label>Select your annual AHA needs:</label>
                    <lib-radio-select
                        name="ahas-combos-radio-select"
                        :options="ahasOptions"
                        :value="value.comboAhas"
                        @input="$emit('input', {...value, comboAhas: $event})"
                    ></lib-radio-select>
                    <label>Select your annual Plan needs:</label>
                    <lib-radio-select
                        name="plans-combos-radio-select"
                        :options="plansOptions"
                        :value="value.comboPlans"
                        @input="$emit('input', {...value, comboPlans: $event})"
                    ></lib-radio-select>
                </div>
                <lib-pricing-widget
                    :yearly="comboYearly"
                    :combo-discount="comboTotalDiscount"
                ></lib-pricing-widget>
                <slot
                    :can-purchase="!!comboYearly"
                    :cart="comboCart"
                ></slot>
            </div>
        </div>
        <div class="contact-us">
            Don’t see what you need? Contact us for custom pricing. <a href="/contact-us" class="lib-arrow-link">CONTACT US</a>
        </div>
        <div class="info-wrapper" v-if="ahaInfo" @click="hideAhaInfo">
            <div class="info-popup aha-info" @click.stop @click="closeDivisions">
                <i class="fa fa-times" @click="hideAhaInfo"></i>
                <div class="header">
                    <div class="title">Activity Hazard Analysis</div>
                    <div class="detail">Complete with automatic translation into more than 40 languages.</div>
                </div>
                <div class="info-main">
                    <div class="features-box">
                        <div class="label">
                            <div>CURRENT LIST OF PRE-WRITTEN AHAS AVAILABLE WITH A SUBSCRIPTION:</div>
                            <input type="text" id="ahaFilter" v-model="filterText" placeholder="Search here..." @click.stop>
                        </div>
                        <div class="features">
                            <ul class="aha-division-list" @click.stop>
                                <li
                                    class="aha-division"
                                    :class="{shown: division.shown}"
                                    v-for="division in divisions"
                                    @click="division.shown = !division.shown" v-if="!filterText || division.ahas.some(aha => ahaFiltering(aha, filterText))">
                                    <div class="division-box">
                                        {{division.code}} {{division.title}}
                                        <span class="collapsable-icon" v-if="!division.shown">+</span>
                                        <span class="collapsable-icon" v-if="division.shown">−</span>
                                    </div>
                                    <ul class="individual-aha-list" v-if="division.shown || (filterText && filterText.length > 3)" @click.stop>
                                        <li v-for="aha in division.ahas" v-if="!filterText || ahaFiltering(aha, filterText)">
                                            {{aha.code}} {{aha.title}}
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div class="footer">Still not sure?
                            <a href="/webinar-signup" class="link" target="_blank">Contact us for a free webinar!</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="info-wrapper" v-if="planInfo" @click="hidePlanInfo">
            <div class="info-popup" @click.stop>
                <i class="fa fa-times" @click="hidePlanInfo"></i>
                <div class="header">
                    <div class="title">Safety & Admin Plans</div>
                    <div class="detail">Complete, fully-editable administrative and safety plans.</div>
                </div>
                <div class="info-main">
                    <div class="features-box">
                        <div class="label">INCLUDES:</div>
                        <div class="features">
                            <div class="features-column">
                                <ul>
                                    <li class="feature">Accident Prevention Plan</li>
                                    <li class="feature">Assured Equipment Grounding Conductor Program</li>
                                    <li class="feature">Blood Borne Pathogen Program</li>
                                    <li class="feature">Confined Space Plan</li>
                                    <li class="feature">Covid-19 Exposure Prevention Plan</li>
                                    <li class="feature">Crane Safety Plan</li>
                                    <li class="feature">Crystalline Sillica Exposure Control Plan</li>
                                    <li class="feature">Demolition Plan</li>
                                    <li class="feature">Drug Free Workplace Program</li>
                                </ul>
                            </div>
                            <div class="features-column">
                                <ul>
                                    <li class="feature">Electrical & Arc Flash Safety Program</li>
                                    <li class="feature">Environmental Protection Plan</li>
                                    <li class="feature">Excavation & Trenching Plan</li>
                                    <li class="feature">Fall Protection Plan</li>
                                    <li class="feature">Fall Rescue Plan</li>
                                    <li class="feature">Fatigue Management Plan</li>
                                    <li class="feature">Fertilizer & Pesticide Treatment Plan</li>
                                    <li class="feature">Fire Prevention Plan</li>
                                </ul>
                            </div>
                            <div class="features-column">
                                <ul>
                                    <li class="feature">Hazard Communication Plan</li>
                                    <li class="feature">Hazardous Energy Control Plan</li>
                                    <li class="feature">Health and Safety Plan</li>
                                    <li class="feature">Heat & Cold Stress Management </li>
                                    <li class="feature">Hearing Conservation Program</li>
                                    <li class="feature">Lead Awareness Proection Program</li>
                                    <li class="feature">Quality Control Plan</li>
                                    <li class="feature">Waste Management Plan</li>
                                </ul>
                            </div>
                        </div>
                        <div class="footer">Don’t see the document you need?
                            <a href="/contact-us" class="link" target="_blank">Contact Us!</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LibPricingWidget from './LibPricingWidget';
import divisionsFallback from "../data/divisionsFallback.json";
import LibRadioSelect from "./LibRadioSelect.vue";

export default {
    name: 'PricingPage',
    components: {LibRadioSelect, LibPricingWidget},
    props: ['value'],
    data: function () {
        return {
            loggedIn: false,
            ahasOptions: [
                {description: '25 AHAs per year', yearly: 695, comboDiscount: 35},
                {description: '50 AHAs per year', yearly: 995, comboDiscount: 100},
                {description: 'Unlimited AHAs per year', yearly: 2195, comboDiscount: 330},
            ],
            plansOptions: [
                {description: '3 Plans per year', yearly: 595, comboDiscount: 30},
                {description: '20 Plans per year', yearly: 1195, comboDiscount: 120},
                {description: 'Unlimited Plans per year', yearly: 2495, comboDiscount: 375},
            ],
            divisions: divisionsFallback,
            ahaInfo: false,
            planInfo: false,
            hideAhaLibrary: true,
            filterText: "",
        }
    },
    computed: {
        onlyAhasOptions() {
            return [{description: 'Single AHA - One Time Cost', oneTime: 99}, ...this.ahasOptions]
        },
        ahasCart: function () {
            var items = {};
            if (this.value.ahas === 0) {
                items["ahas"] = "single"
            } else if (this.value.ahas === 1) {
                items["ahas"] = "basic"
            } else if (this.value.ahas === 2) {
                items["ahas"] = "project"
            } else if (this.value.ahas === 3) {
                items["ahas"] = "business"
            }
            return items;
        },
        plansCart: function () {
            var items = {};
            if (this.value.plans === 0) {
                items["plans"] = "basic"
            } else if (this.value.plans === 1) {
                items["plans"] = "project"
            } else if (this.value.plans === 2) {
                items["plans"] = "business"
            }
            return items;
        },
        comboCart: function () {
            var items = {};
            if (this.value.comboAhas === 0) {
                items["ahas"] = "basic"
            } else if (this.value.comboAhas === 1) {
                items["ahas"] = "project"
            } else if (this.value.comboAhas === 2) {
                items["ahas"] = "business"
            }
            if (this.value.comboPlans === 0) {
                items["plans"] = "basic"
            } else if (this.value.comboPlans === 1) {
                items["plans"] = "project"
            } else if (this.value.comboPlans === 2) {
                items["plans"] = "business"
            }
            return items;
        },
        ahasYearly: function() {
            return this.onlyAhasOptions[this.value.ahas].yearly;
        },
        ahasOneTime: function() {
            return this.onlyAhasOptions[this.value.ahas].oneTime;
        },
        plansYearly: function() {
            return this.plansOptions[this.value.plans].yearly;
        },
        comboAhasYearly: function() {
            return this.ahasOptions[this.value.comboAhas].yearly;
        },
        comboPlansYearly: function() {
            return this.plansOptions[this.value.comboPlans].yearly;
        },
        comboTotalDiscount: function() {
            if (this.plansOptions[this.value.comboPlans].comboDiscount && this.ahasOptions[this.value.comboAhas].comboDiscount) {
                return this.ahasOptions[this.value.comboAhas].comboDiscount + this.plansOptions[this.value.comboPlans].comboDiscount;
            } else {
                return null;
            }
        },
        comboYearly: function() {
            if (this.comboAhasYearly && this.comboPlansYearly) {
                return this.comboAhasYearly + this.comboPlansYearly - this.comboTotalDiscount;
            } else {
                return null;
            }
        },
    },
    methods: {
        asMonthly: function(yearly) {
            return yearly ? Math.ceil(yearly / 12) : null
        },
        showAhaInfo() {
            if (!this.ahaInfo) {
                this.ahaInfo = true;
            }
        },
        showPlanInfo() {
            if (!this.planInfo) {
                this.planInfo = true;
            }
        },
        hideAhaInfo() {
            if (this.ahaInfo) {
                this.ahaInfo = false;
                this.closeDivisions();
                this.hideAhaLibrary = true;
            }
        },
        hidePlanInfo() {
            if (this.planInfo) {
                this.planInfo = false;
            }
        },
        closeDivisions() {
            for (let i = 0; i < this.divisions.length; i++) {
                this.divisions[i].shown = false;
            }
        },
        ahaFiltering(aha, filterText) {
            return (
                aha.title.includes(filterText.toUpperCase())
                || (aha.code && aha.code.includes(filterText.toUpperCase()))
            )
        },
    },
    watch: {
      'value.ahas'(newValue) {
        if (newValue > 0) {
          this.value.comboAhas = newValue - 1;
        }
      },
      'value.plans'(newValue) {
        this.value.comboPlans = newValue;
      },
      'value.comboAhas'(newValue) {
        this.value.ahas = newValue + 1;
      },
      'value.comboPlans'(newValue) {
        this.value.plans = newValue;
      },
    },
    mounted() {
        jQuery.getJSON("/aha-options", {}, (data) => {
            for (let i = 0; i < data.length; i++) {
                data[i].shown = false;
            }
            this.divisions = data;
        })
    }
};
</script>

<style scoped lang="scss">
@import "../../styles/prelude";


.contact-us {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 24px;
    line-height: 32px;
    text-align: center;
    margin-top: 80px;

    a {
        font-size: 16px;
        line-height: 16px;
        vertical-align: center;
        margin-left: 30px;
    }
}

.info-wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 10;

    #ahaFilter {
        width: auto;
    }

    ul {
        list-style: none;

        li:before {
            content: "•";
            font-size: 4pt;
            color: #20262B;
            padding-right: 1rem;
        }
    }

    .package-option {
        display: flex;
        justify-content: space-between;
    }

    .info-popup {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        max-width: 860px;
        opacity: 1;
        position: relative;
        top: 80px;
        margin: 0 auto;
        padding: 4rem 4rem 3rem;

        &.aha-info {
            top: 80px;
            padding: 3rem;
        }

        .info-main {
            display: flex;

            .features-box {
                flex: 3;
                margin-right: 1rem;

                .features {
                    display: flex;
                    justify-content: space-between;
                }
            }

            .right-column {
                flex: 1;
                border-left: 1px solid #d2d7da;
                padding-left: 3rem;
                padding-right: 3rem;
            }

            .package-option {
                text-align: left;
                letter-spacing: 0px;
                color: #20262B;
                font: 14px Lato;
                opacity: 1;
                margin: 2rem 0;

                .package-title {
                    font-weight: bold;

                    .description {
                        font-weight: normal;
                    }
                }
            }
        }

        .fa-times {
            text-align: left;
            font: normal normal normal 18px/21px Font Awesome 6 Pro;
            color: #828588;
            opacity: 1;
            position: absolute;
            top: 2rem;
            right: 2.5rem;

            &:hover {
                cursor: pointer;
            }
        }

        .detail {
            text-align: left;
            font: normal normal normal 20px/24px Lato;
            letter-spacing: 0px;
            color: #20262B;
        }

        .label {
            text-align: left;
            font: normal normal bold 12px/21px Lato;
            letter-spacing: 2.4px;
            color: #264055;
            display: flex;
            justify-content: space-between;
            padding-top: 1rem;
        }

        .header {
            text-align: left;

            .title {
                text-align: left;
                font: normal normal bold 38px/46px Lato;
                letter-spacing: 0;
                color: #20262B;
            }
        }

        .features-box {
            .feature {
                text-align: left;
                font: normal normal normal 12px/15px Lato;
                letter-spacing: 0px;
                color: #20262B;
                opacity: 1;
                margin: 1rem;
            }
        }

        .footer {
            text-align: center;
            font: normal normal normal 20px/24px Lato;
            letter-spacing: 0;
            color: #20262B;
            margin-top: 2rem;
        }
    }
}

.shown {
    font-weight: bold;
}

.aha-division {
    border-radius: 3px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.075), 0 2px 4px rgba(0, 0, 0, 0.0375);
    padding: 3px;

    .division-box {
        display: flex;
        justify-content: space-between;
        min-width: 20rem;
        padding: 0.25rem 0.5rem;

        .collapsable-icon {
            font-size: 18px;
        }
    }

    &:hover {
        cursor: pointer;
        font-weight: bold;

        .individual-aha-list {
            font-weight: normal;
        }
    }
}

.individual-aha-list {
    color: #20262b;
    font-weight: normal;

    &:hover {
        cursor: default;
    }
}

.aha-division-list {
    column-gap: 5rem;
    display: flex;
    flex-wrap: wrap;

    li {
        page-break-inside: avoid;
        break-inside: avoid-column;
    }

    background: no-repeat padding-box;
    font: normal normal normal 12px/15px Lato;

    ul {
        max-height: 75px;
        max-width: 300px;
        overflow: hidden;
        overflow-y: scroll;
    }

    ::before {
        display: none;
    }
}

.lib-cards {
    --link-color: #{$bluegray};
}
</style>